<!-- Trigger no header (CA-BUS-01 / CA-BUS-03)
     EAS-298 (CA-07/CA-08/CA-10): deixou de ser um botão discreto entre os ícones e
     passou a ser barra de fundo branco, com placeholder e atalho visíveis. A ação
     do clique é a mesma de antes — openSearch(), idêntica ao Ctrl+K (CA-10). -->
<button type="button" class="search-trigger" (click)="openSearch()"
        pTooltip="Buscar telas (Ctrl+K)" tooltipPosition="bottom"
        aria-label="Buscar telas do EasyMarine">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round">
    <circle cx="11" cy="11" r="7"></circle>
    <path d="M21 21l-4-4"></path>
  </svg>
  <!-- CA-11: some na faixa estreita, sobrando ícone + atalho, sem perder o clique. -->
  <span class="search-trigger-placeholder">Buscar telas do EasyMarine</span>
  <span class="search-trigger-kbd">Ctrl K</span>
</button>

<!-- Sobreposição (CA-BUS-04) -->
<div class="search-backdrop" *ngIf="open" (click)="onBackdropClick($event)">
  <div class="search-palette">

    <div class="search-input-row">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="7"></circle>
        <path d="M21 21l-4-4"></path>
      </svg>
      <input #searchInput type="text" autocomplete="off" spellcheck="false"
             placeholder="Buscar telas do EasyMarine…"
             [(ngModel)]="query" (ngModelChange)="onInput()">
      <span class="search-esc" (click)="close()">esc</span>
    </div>

    <div class="search-results">
      <!-- Antes de digitar: só orientação (CA-BUS-05) -->
      <div class="search-state" *ngIf="!query.trim()">
        Digite para buscar telas do EasyMarine
      </div>

      <!-- Sem match (CA-BUS-12) -->
      <div class="search-state" *ngIf="query.trim() && results.length === 0">
        Nenhum resultado encontrado
      </div>

      <ng-container *ngIf="query.trim() && results.length">
        <div class="search-results-meta">
          <span class="search-results-label">Telas</span>
          <span class="search-results-filter">Filtrado pelo seu acesso</span>
        </div>

        <div class="search-result" *ngFor="let r of results; let i = index"
             [class.focused]="i === focused"
             (click)="go(r)" (mousemove)="setFocused(i)">
          <span class="search-result-ico">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2"></rect>
              <path d="M3 9h18M9 21V9"></path>
            </svg>
          </span>
          <span class="search-result-text">
            <span class="search-result-name">{{ r.name }}</span>
            <span class="search-result-path" *ngIf="r.path">{{ r.path }}</span>
          </span>
          <span class="search-result-chip" *ngIf="r.aliasHit">apelido «{{ r.aliasHit }}»</span>
        </div>
      </ng-container>
    </div>

    <div class="search-footer">
      <span class="search-foot-hint"><span class="k">↑</span><span class="k">↓</span> Navegar</span>
      <span class="search-foot-hint"><span class="k">↵</span> Abrir</span>
      <span class="search-foot-hint"><span class="k">esc</span> Fechar</span>
    </div>
  </div>
</div>